<div class="form-group">
  <label class="control-label col-form-label-sm" *ngIf="label !== ''">{{label}}</label>
  <input type="{{inputType}}" class="form-control form-control-sm {{additionalClass}} {{ (errorText !== '' ? 'is-invalid' : '') }}" [(ngModel)]="model" (change)="change()" placeholder="{{placeHolder}}" [disabled]="disabled"/>
  <small class="form-text text-muted" [hidden]="helpText === ''">
      {{helpText}}
  </small>
  <div class="invalid-feedback">
    {{errorText | translate}}
  </div>
</div>